import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { getEnv } from './env';
import { isPreviewMode } from './preview/flag';
import { createMockClient } from './preview/client';
import { createCompanyScopedFetch } from './companyContext';

// Single browser data client. In normal mode this is the real Supabase client (Auth + RLS
// reads + SECURITY-DEFINER RPCs) and requires real env vars. In Preview Mode (explicit
// VITE_UI_PREVIEW_MODE=true only) it is a deterministic in-memory mock with no network and
// no real writes — the single runtime adapter-selection point for the whole app.
let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (client === null) {
    if (isPreviewMode()) {
      client = createMockClient() as SupabaseClient;
    } else {
      const env = getEnv();
      client = createClient(env.supabaseUrl, env.supabaseAnonKey, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
        },
        global: {
          fetch: createCompanyScopedFetch(),
        },
      });
    }
  }
  return client;
}
